import React, { useState, memo, useEffect } from "react";
import { Flex } from "rebass/styled-components";
import Lottie from "lottie-react";
import Loading from "../../animations/loading.json";
import { SettingsContainer } from "../../components/molecules/settingsContainer";
import { Body } from "../../components/text";
import { DividerAlt } from "../../components/atoms/dividerAlt";
import { GoAlert } from "react-icons/go";
import Toggle from "../../components/atoms/toggle";
import { getUsersContactPreferences } from "../../dataLayer/dataGet";
import { setUsersContactPreferences } from "../../dataLayer/dataPatch";
import { space } from "styled-system";
import { Error } from "../../components/atoms/form/error";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { analytics } from "MVVM/Analytics";

const lottieStyle = {
  height: 28,
  width: 28,
};

const AlertIcon = styled(GoAlert)(space);
const Notifications = memo(() => {
  let [state, setState] = useState({
    error: false,
    loading: true,
    showWarning: false,
    emailPrefs: [],
    activePrefs: [],
  });

  useEffect(() => {
    (async () => {
      let res = await getUsersContactPreferences();
      if (!(res.status === 200) || !res?.data?.data?.email)
        return setState({
          error: true,
          errorMsg: `Something went wrong retrieving your Email Preferences. Please contact support on Discord or email us at support@allstar.gg.`,
        });
      else {
        let activePrefs = [];

        let active = res?.data?.data?.email.filter((pref) => {
          return pref.status;
        });
        active.forEach((pref) => {
          activePrefs.push(pref.context);
        });

        return setState({
          ...state,
          error: false,
          loading: false,
          emailPrefs: res?.data?.data?.email,
          activePrefs: activePrefs,
        });
      }
    })();
  }, []); //eslint-disable-line

  const handleChange = async (isToggled, key) => {
    let onOrOff = isToggled ? "on" : "off";
    let activePrefs = state.activePrefs;

    if (isToggled && !activePrefs.includes(key)) {
      activePrefs.push(key);
    } else if (!isToggled && activePrefs.includes(key)) {
      activePrefs = activePrefs.filter((pref) => {
        return !(pref === key);
      });
    }

    setState({ ...state, activePrefs: activePrefs, showWarning: true });
    let res = await setUsersContactPreferences(key, onOrOff);
    if (!(res.status === 200) || !res?.data?.data?.email)
      return setState({
        error: true,
        errorMsg: `Something went wrong setting your Email Preferences. Please contact support on Discord or email us at support@allstar.gg.`,
      });
    else {
      analytics.track(`${key} - Email Preferences Toggle ${onOrOff}`, {});
    }
  };
  const { t } = useTranslation(`translation`, {
    keyPrefix: "profile.notifications",
  });
  const EMAIL_CONTEXTS = [
    {
      key: "Marketing",
      text: t(`toggleTwo`),
    },
    {
      key: "Giveaway",
      text: t(`toggleThree`),
    },
    {
      key: "SuggestedClip",
      text: t(`toggleFour`),
    },
  ];
  return (
    <>
      <SettingsContainer title={t("emailPreferences")} mb={6}>
        <DividerAlt></DividerAlt>
        {state.loading ? (
          <>
            {" "}
            <Flex justifyContent={"center"}>
              <Lottie animationData={Loading} style={lottieStyle} loop={true} />
            </Flex>
          </>
        ) : (
          <>
            {state.error ? (
              <>
                <Error>{state.errorMsg}</Error>
              </>
            ) : (
              <>
                <Flex
                  mb={2}
                  flexDirection="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Body color="chalk">{t("toggleOne")}</Body>
                  <Toggle
                    // onChange={handleMouseClick}
                    checked={true}
                    onChange={() => {
                      handleChange();
                    }}
                    disabled={true}
                  />
                </Flex>
                <Body color="error" mb={6} fontSize={1}>
                  This setting cannot be disabled. We need to be able to contact
                  you about important updates and changes to your account.
                </Body>
                {EMAIL_CONTEXTS.map((context, i, array) => {
                  return (
                    <Flex
                      mb={i + 1 === array.length ? 0 : 6}
                      flexDirection="row"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Body color="chalk">{context.text}</Body>

                      <Toggle
                        // onChange={handleMouseClick}
                        checked={
                          state.activePrefs.filter((pref) => {
                            return pref === context.key;
                          }).length > 0
                        }
                        onChange={(isToggled) => {
                          handleChange(isToggled, context.key);
                        }}
                      />
                    </Flex>
                  );
                })}
              </>
            )}
          </>
        )}
        {state.showWarning ? (
          <Flex color={"error"} mt={4}>
            <AlertIcon size={22} mr={4} justifyContent={"center"}></AlertIcon>
            <Body>Changes may take at least 24 hours to take effect.</Body>
          </Flex>
        ) : (
          <></>
        )}
      </SettingsContainer>
    </>
  );
});

export { Notifications };
